import { ROLES } from "../constants/roles";
import { STATUS } from "../constants/status";

export const checkPermission = (
  userRole,
  iouStatus,
  isCreator,
  action,
  departmentApprove,
  directorApprove,
) => {
  const permissions = {
    [STATUS.CREATED]: {
      user: {
        view: (creator) => creator,
        update: (creator) => creator,
        reject: () => false,
        request: (creator) => creator,
        approve: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
    },
    [STATUS.REQUESTED_BY_USER]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => true,
        reject: () => true,
        request: () => false,
        approve: () => true,
      },
      [ROLES.DIRECTOR]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
    },
    [STATUS.APPROVED_BY_DEPT_HEAD]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => true,
        reject: () => true,
        request: () => false,
        approve: () => true,
      },
    },
    [STATUS.REJECTED]: {
      user: {
        view: (creator) => creator,
        update: (creator) => creator,
        reject: () => false,
        request: (creator) => creator,
        approve: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => false,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
    },
    [STATUS.APPROVED_BY_DIRECTOR]: {
      user: {
        view: (creator) => creator,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
    },
    [STATUS.REJECTED]: {
      user: {
        view: (creator) => creator,
        update: (creator) => creator,
        reject: () => false,
        request: (creator) => creator,
        approve: () => false,
      },
      [ROLES.DEPARTMENT_HEAD]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
      [ROLES.DIRECTOR]: {
        view: () => true,
        update: () => false,
        reject: () => false,
        request: () => false,
        approve: () => false,
      },
    },
  };

  if (departmentApprove === "approved") {
    permissions[STATUS.REJECTED][ROLES.DEPARTMENT_HEAD] = {
      view: () => true,
      update: () => false,
      reject: () => false,
    };
    permissions[STATUS.REJECTED][ROLES.DIRECTOR] = {
      view: () => true,
      update: () => true,
    };
  } else if (departmentApprove === "rejected") {
    permissions[STATUS.REJECTED][ROLES.DEPARTMENT_HEAD] = {
      view: () => true,
      update: () => false,
      reject: () => false,
    };
    permissions[STATUS.REJECTED][ROLES.DIRECTOR] = {
      view: () => false,
      update: () => false,
    };
  }

  if (directorApprove === "approved") {
    permissions[STATUS.REJECTED][ROLES.DIRECTOR] = {
      view: () => true,
      update: () => false,
    };
  } else if (directorApprove === "rejected") {
    permissions[STATUS.REJECTED][ROLES.DIRECTOR] = {
      view: () => true,
      update: () => false,
    };
  }

  const statusPerms = permissions[iouStatus];
  if (!statusPerms) return false;

  const rolePerms = statusPerms[userRole] || statusPerms["user"];
  if (!rolePerms) return false;

  const actionPerm = rolePerms[action];
  if (!actionPerm) return false;

  return actionPerm(isCreator);
};
